<template>
  <div class="mx-sm-1 mt-9">
    <div class="page-header">
        <h1 class="page-title fw-bold">Les Météos</h1>
        <div>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link :to="{ name: 'dashboard' }"><a>Tableau de bord</a></router-link></li>
                <li class="breadcrumb-item" aria-current="page"><router-link :to="{ name: 'composantes', params: { showList: true }}"><a>Portefeuille</a></router-link></li>
                <li class="breadcrumb-item active" aria-current="page"><router-link :to="{ name: 'meteos' }"><a>Les Météos</a></router-link></li>
            </ol>
        </div>
    </div>
    <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12" v-if="showList">
            <div class="card">
                <div class="card-header">
                    <h3 class="card-title fw-bold">Liste des météos</h3>
                    <div class="card-options">
                        <SearchInputAll></SearchInputAll>
                        <button class="btn btn-outline-dark mx-5" @click="sentBackPortefeuille"><span class="fe fe-arrow-left-circle"></span> Retour sur Portefeuille</button>
                    </div>
                </div>
                <div class="card-body pt-4">
                    <div class="grid-margin">
                        <div class="panel panel-primary">
                            <div class="panel-body tabs-menu-body border-0 pt-0">
                                <div class="tab-content">
                                    <div class="tab-pane active" id="tab5">
                                        <div class="table-responsive">
                                            <div class="mb-3">
                                            <div class="mb-3 d-flex">
                                                <div class="form-row col-sm-12">
                                                    <button class="btn btn-primary col-sm-2" title="Les Filtres" @click="showFilter = !showFilter">
                                                        <span><i class="fe fe-filter text-white" style="font-size: 15px;"></i> Filtres</span>
                                                    </button>
                                                    <multi-select class="col-sm-5" @select="o => o.used = true" :options="columns.filter(o => !o.used)" v-if="showFilter"
                                                        :custom-label="v => v.description" placeholder="Filtrer par " label="name" track-by="name"></multi-select>
                                                    <!-- <multi-select class="col-sm-5" deselect-label="Sélectionné" select-label="" :options="classeurs" @select="handleSelectClasseur(classeur)"
                                                        placeholder="Filtrer par classeur" label="nomClasseur" track-by="idClasseur" :searchable="true" v-if="showFilter"
                                                        :custom-label="o => o.idClasseur + ' - ' + o.nomClasseur" v-model="classeur">
                                                        <template slot="singleLabel" slot-scope="{ option }">
                                                            <strong> {{ option.nomClasseur }}</strong>
                                                        </template>
                                                    </multi-select> -->
                                                </div>
                                            </div>
                                            <div class="row" v-if="showFilter">
                                                <div v-for="(item, index) in filters" :key="`filter${index}`" class="form-group col-sm-4">
                                                    <div class="input-group">
                                                        <select v-if="item.options" v-model="item.value" class="form-select">
                                                            <option v-for="(obj, i) in item.options" :key="i" :value="obj.key">{{ obj.value }}</option>
                                                        </select>
                                                        <input v-else :type="item.type" class="form-control" :placeholder="`Recherche de ${item.description}`"
                                                                v-model="item.value">
                                                        <div class="input-group-append">
                                                            <button class="btn btn-danger" type="button" @click="onSearchBack(item)">
                                                                <i class="fe fe-trash-2"></i></button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="form-group col-sm-4" v-if="filters.length > 0">
                                                    <button class="btn btn-dark" tabindex="1" type="button" @click.prevent="onSearch">
                                                        <span><i class="fe fe-search"></i> Appliquer</span>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                            <div class="table-responsive">
                                                <table id="data-table"
                                                    class="table table-hover table-bordered text-nowrap mb-0">
                                                    <thead class="border-top success02">
                                                        <tr>
                                                            <!-- <th class="bg-transparent border-bottom-0 fw-bold" >Actions</th> -->
                                                            <th class="bg-transparent border-bottom-0 fw-bold"
                                                                @click="sortBy('idComposante')">Id Composante</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('nomComposante')">
                                                                Composante</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"  @click="sortBy('etatComposante')">
                                                                Etat</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"  @click="sortBy('statut')">
                                                                Statut</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"  @click="sortBy('meteo')">
                                                                Météo</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"  @click="sortBy('etudes')">
                                                                Etudes</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"  @click="sortBy('gouvernance')">
                                                                Gouvernance</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"  @click="sortBy('contrat')">
                                                                Contrat</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"  @click="sortBy('execution')">
                                                                Exécution</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"  @click="sortBy('miseEnService')">
                                                                Mise en service</th>
                                                            <th class="bg-transparent border-bottom-0 fw-bold"  @click="sortBy('tepGlobal')">
                                                                TEP Global</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody v-if="filtersItems[0]" id="myTable1">
                                                        <tr v-for="(item, index) in filtersItems" :key="index" class="border-bottom">
                                                            <!-- <td class="text-center">
                                                                <div class="g-2">
                                                                    <button class="modal-effect btn text-primary btn-sm" @click.prevent="showFormMeteo(item)"
                                                                        title="Déclarer une nouvelle météo" data-bs-original-title="Déclarer une nouvelle météo" data-bs-effect="effect-scale"
                                                                        data-bs-toggle="modal">
                                                                        <span class="fe fe-plus-square fs-18"></span></button>
                                                                    <button class="modal-effect btn text-warning btn-sm" @click.prevent="showHistoriqueMeteo(item)"
                                                                        title="Historique des météos" data-bs-original-title="Historique des météos" data-bs-effect="effect-scale"
                                                                        data-bs-toggle="modal">
                                                                        <span class="fe fe-layers fs-18"></span></button>
                                                                </div>
                                                            </td> -->
                                                            <td class="text-center" >{{ item?.idComposante }}</td>
                                                            <td class="composante-nom" style="width: 25%;">{{ item?.nomComposante }}</td>
                                                            <td class="text-center" >
                                                                <div class="mt-0 mt-sm-3 d-block">
                                                                    <span class="p-2 px-3 alert" :style="'background-color: '  + statusEtat(item?.etatComposante?.etat)">{{ item?.etatComposante?.libelle }}</span>
                                                                </div>
                                                            </td>
                                                            <td class="text-center" >
                                                                <div class="mt-0 mt-sm-3 d-block">
                                                                    <span class="p-2 px-3 alert" :style="'background-color: '  + statusStatut(item?.statut?.statut)">{{ item?.statut?.libelle }}</span>
                                                                </div>
                                                            </td>
                                                            <td class="text-center" :style="'background-color: '  + couleurMeteo(item?.couleur)">
                                                                <span><small class="fw-bold">{{ item?.couleur ? item?.couleur : 'Blanc' }}</small></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.etudes), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.etudes ? item?.etudes : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.gouvernance), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.gouvernance ? item?.gouvernance : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.contrat), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.contrat ? item?.contrat : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.execution), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.execution ? item?.execution : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="d-inline-block rounded-circle" :style="{
                                                                    backgroundColor: couleurCritere(item?.miseEnService), width: '30px', height: '30px', border: '1px solid #000000',
                                                                    }" :title="item?.miseEnService ? item?.miseEnService : 'Non renseigné'"></span>
                                                            </td>
                                                            <td class="text-center">
                                                                <span class="badge bg-success badge-sm me-1 mb-1 mt-1 rounded-pill fw-bold" style="font-size: 13px;">{{ item?.tepGlobal ? item?.tepGlobal : '0' }}</span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                    <tbody v-else>
                                                        <tr class="primary02">
                                                            <td colspan="12" class="text-center">Aucune composante trouvée</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                            <paginate :records="items.totalElements || 0" v-model="items.number" :per-page="items.size"
                                                :options="{ theme: 'bootstrap4', edgeNavigation: true, texts: { count: `{from} à {to} de {count} éléments|{count} éléments|Un élément`, first: '<<<', last: '>>>' } }"
                                                @paginate="onSearch" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal fade" id="detail-composante-meteo" tabindex="-1" role="dialog">
                <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-primary text-white">
                            <h6 class="modal-title fw-bold" style="font-size: 16px;">Historique des météos de la composante sélectionnée</h6><button aria-label="Close" class="btn-close text-white"
                                data-bs-dismiss="modal" type="button"><span aria-hidden="true">×</span></button>
                        </div>
                        <div class="modal-body">
                            <ul class="row p-3">
                                <li class="col-lg-12 mb-2">
                                    <h4 class="fw-bold">Composante : {{ composante?.idComposante }} --- {{ composante?.nomComposante }}</h4>
                                </li>
                                <li class="col-lg-12 mb-2">
                                    <div class="table-responsive">
                                        <table class="table table-hover table-bordered">
                                            <thead class="border-top success02">
                                                <tr>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('declaredAt')">
                                                        Date déclaration
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('validated')">
                                                        Validé ?
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('approvedAt')">
                                                        Date validation
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('couleur')">
                                                        Météo
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('etudes')">
                                                        Etudes
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('gouvernance')">
                                                        Gouvernance
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('contrat')">
                                                        Contrat
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('execution')">
                                                        Exécution
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold" @click="sortBy('miseEnService')">
                                                        Mise en service
                                                    </th>
                                                    <th class="bg-transparent border-bottom-0 fw-bold"
                                                        style="width: 5%;">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody v-if="filtersItemsMeteos.length > 0" id="myTable1">
                                                <tr v-for="(item, index) in filtersItemsMeteos" :key="index" class="border-bottom">
                                                    <td>{{ item?.declaredAt == 'Invalid date' || item?.declaredAt == null ? '-' : item?.declaredAt | moment('DD-MM-YYYY HH:mm') }}</td>
                                                    <td class="text-center">
                                                        <span class="fw-bold badge rounded-pill p-2" :class="item?.validated ? 'bg-success' : 'bg-warning'">{{ item?.validated ? 'OUI' : 'NON' }}</span>
                                                    </td>
                                                    <td>{{ item?.approvedAt == 'Invalid date' || item?.approvedAt == null ? '-' : item?.approvedAt | moment('DD-MM-YYYY HH:mm') }}</td>
                                                    <td class="text-center" :style="'background-color: '+ couleurMeteo(item?.couleur)">
                                                        <small class="fw-bold">{{ item?.couleur ? item?.couleur : 'Blanc' }}</small>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="d-inline-block rounded-circle" :style="{
                                                            backgroundColor: couleurCritere(item?.etudes), width: '30px', height: '30px', border: '1px solid #000000',
                                                            }" :title="item?.etudes ? item?.etudes : 'Non renseigné'"></span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="d-inline-block rounded-circle" :style="{
                                                            backgroundColor: couleurCritere(item?.gouvernance), width: '30px', height: '30px', border: '1px solid #000000',
                                                            }" :title="item?.gouvernance ? item?.gouvernance : 'Non renseigné'"></span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="d-inline-block rounded-circle" :style="{
                                                            backgroundColor: couleurCritere(item?.contrat), width: '30px', height: '30px', border: '1px solid #000000',
                                                            }" :title="item?.contrat ? item?.contrat : 'Non renseigné'"></span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="d-inline-block rounded-circle" :style="{
                                                            backgroundColor: couleurCritere(item?.execution), width: '30px', height: '30px', border: '1px solid #000000',
                                                            }" :title="item?.execution ? item?.execution : 'Non renseigné'"></span>
                                                    </td>
                                                    <td class="text-center">
                                                        <span class="d-inline-block rounded-circle" :style="{
                                                            backgroundColor: couleurCritere(item?.miseEnService), width: '30px', height: '30px', border: '1px solid #000000',
                                                            }" :title="item?.miseEnService ? item?.miseEnService : 'Non renseigné'"></span>
                                                    </td>
                                                    <td class="text-center">
                                                        <div class="g-2 d-flex">
                                                            <button class="btn text-primary btn-sm" @click.prevent="edit(item)"
                                                                data-bs-toggle="tooltip" title="Modifier"
                                                                data-bs-original-title="Edit"><span
                                                                    class="fe fe-edit fs-18"></span></button>
                                                            <button
                                                                class="btn text-danger btn-sm" @click.prevent="drop(item)"
                                                                    data-bs-toggle="tooltip" title="Supprimer"
                                                                    data-bs-original-title="Delete"><span
                                                                        class="fe fe-trash-2 fs-18"></span></button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody v-else>
                                                <tr class="primary02">
                                                    <td colspan="8" class="text-center">Aucune météo trouvée.</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <nav class="mt-2">
                                        <ul class="pagination justify-content-end">
                                            <li class="page-item" :class="{ disabled: currentPage === 1 }">
                                                <a class="page-link" href="#" @click.prevent="changePage(currentPage - 1)">&laquo;</a>
                                            </li>
                                            <li v-for="page in pageCount" :key="page" class="page-item" :class="{ active: currentPage === page }">
                                                <a class="page-link" href="#" @click.prevent="changePage(page)">{{ page }}</a>
                                            </li>
                                            <li class="page-item" :class="{ disabled: currentPage === pageCount }">
                                                <a class="page-link" href="#" @click.prevent="changePage(currentPage + 1)">&raquo;</a>
                                            </li>
                                        </ul>
                                    </nav>
                                </li>
                            </ul>
                        </div>
                        <div class="modal-footer">
                            <button class="btn btn-dark" data-bs-dismiss="modal">Fermer</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- COL END -->
         <div class="row" v-else>
            <div class="col-sm-12 col-md-12">
                <div class="card">
                    <div class="card-header">
                        <h3 class="card-title">Création d'une météo</h3>
                        <div class="card-options">
                            <button class="btn btn-outline-dark mx-5" @click="sentBackPortefeuille"><span class="fe fe-arrow-left-circle"></span> Retour sur Portefeuille</button>
                        </div>
                    </div>
                    <ValidationObserver v-slot="{ invalid }">
                        <form @submit.prevent="submit">
                            <div class="card-body">
                                <div class="form-row">
                                    <div class="form-group col-md-6">
                                        <ValidationProvider name="idComposante" rules="required" v-slot="{ errors }">
                                            <label class="form-label">Composante <span class="text-danger">*</span></label>
                                            <multi-select v-model="payload.idComposante" deselect-label="Sélectionné" select-label="" :options="composantes"
                                                            placeholder="Sélectionné la composante" label="nomComposante" track-by="idComposante" :searchable="true"
                                                            :custom-label="o => o.idComposante + ' - ' + o.nomComposante" @select="selectComposante(payload.idComposante)">
                                                <template slot="singleLabel" slot-scope="{ option }">
                                                    <strong> {{ option.nomComposante }}</strong>
                                                </template>
                                                <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                                                <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                                            </multi-select>
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <ValidationProvider name="tepGlobal" rules="min_value:0|max_value:100" v-slot="{ errors }">
                                            <label class="form-label">TEP Global (%) </label>
                                            <input type="text" name="tepGlobal" v-model="payload.idComposante.tepGlobal" id="tepGlobal" class="form-control" readonly />
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group col-md-3">
                                        <ValidationProvider name="etatComposante" rules="" v-slot="{ errors }">
                                            <label class="form-label">Etat ou Implication ASIN </label>
                                            <!-- <multi-select v-model="payload.idComposante.etatComposante" deselect-label="Sélectionné" select-label="" :options="etatComposantes"
                                                            placeholder="Sélectionné l'état de la composante" label="libelle" track-by="etat" 
                                                            :searchable="true" readonly>
                                                <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                                                <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                                            </multi-select> -->
                                            <input type="hidden" name="etatComposante" v-model="payload.idComposante.etatComposante.etat" />
                                            <input type="text" name="etatComposanteLibelle" v-model="payload.idComposante.etatComposante.libelle" id="etatComposante" class="form-control" readonly />
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="declaredAt" rules="required" v-slot="{ errors }">
                                            <label class="form-label">Déclarer le <span class="text-danger">*</span></label>
                                            <date-pick :language="fr" :bootstrapStyling="true" minimumView="day" name="declaredAt"
                                                    v-model="payload.declaredAt" placeholder="Sélectionnez une date" :disabled="true"
                                                    calendar-button-icon="fe fe-calendar" @input="verifyCouleur(payloadCritere)" />
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <div class="form-group col-md-6 mb-0">
                                        <ValidationProvider name="commentaire" rules="" v-slot="{ errors }">
                                            <label class="form-label">Commentaire</label>
                                            <!-- <input type="text" class="form-control" id="commentaire" v-model="payload.commentaire" placeholder="saisir la météo"> -->
                                            <textarea name="commentaire" v-model="payload.commentaire" class="form-control" id="commentaire" rows="3"></textarea>
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="form-row items-center justify-content-center">
                                    <div class="form-group col-md-2 mb-0">
                                        <ValidationProvider name="etudes" rules="" v-slot="{ errors }">
                                            <label class="form-label">Etudes </label>
                                            <!-- <input type="text" class="form-control" name="etudes" id="etudes" v-model="payload.etudes" 
                                            placeholder="saisir la pondération du critère..." @change="verifyCouleur(payload)"> -->
                                            <multi-select v-model="payloadCritere.etudes" deselect-label="Sélectionné" select-label="" :options="criteres"
                                                            placeholder="Sélectionné la pondération du critère..." label="libelle" track-by="critere" @select="verifyCouleur(payloadCritere)"
                                                            :searchable="true">
                                                <template slot="option" slot-scope="{ option }">
                                                    <div class="p-1 text-white"
                                                        :style="{ backgroundColor: option.couleur, padding: '5px 10px' }">
                                                        {{ option.libelle }}
                                                    </div>
                                                </template>
                                                <template slot="singleLabel" slot-scope="{ option }">
                                                    <div class="p-1 text-white" 
                                                        :style="{ backgroundColor: option.couleur, padding: '5px 10px' }">
                                                        {{ option.libelle }}
                                                    </div>
                                                </template>
                                                <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                                                <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                                            </multi-select>
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <!-- <div class="col-md-2 mb-0 mt-6">
                                        <span class="d-inline-block rounded-circle" :style="{
                                                    backgroundColor: couleurCritere(payload?.etudes), width: '30px', height: '30px', border: '1px solid #000000',
                                                    }" :title="payload?.etudes ? payload?.etudes : 'Non renseigné'"></span>
                                    </div> -->
                                
                                    <div class="form-group col-md-2 mb-0">
                                        <ValidationProvider name="gouvernance" rules="" v-slot="{ errors }">
                                            <label class="form-label">Gouvernance </label>
                                            <!-- <input type="text" class="form-control" name="gouvernance" id="gouvernance" v-model="payload.gouvernance" 
                                            placeholder="saisir la pondération du critère..." @change="verifyCouleur(payload)"> -->
                                            <multi-select v-model="payloadCritere.gouvernance" deselect-label="Sélectionné" select-label="" :options="criteres"
                                                            placeholder="Sélectionné la pondération du critère..." label="libelle" track-by="critere" @select="verifyCouleur(payloadCritere)"
                                                            :searchable="true">
                                                <template slot="option" slot-scope="{ option }">
                                                    <div class="p-1 text-white"
                                                        :style="{ backgroundColor: option.couleur, padding: '5px 10px' }">
                                                        {{ option.libelle }}
                                                    </div>
                                                </template>
                                                <template slot="singleLabel" slot-scope="{ option }">
                                                    <div class="p-1 text-white" 
                                                        :style="{ backgroundColor: option.couleur, padding: '5px 10px' }">
                                                        {{ option.libelle }}
                                                    </div>
                                                </template>
                                                <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                                                <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                                            </multi-select>
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <!-- <div class="col-md-2 mb-0 mt-6">
                                        <span class="d-inline-block rounded-circle" :style="{
                                                    backgroundColor: couleurCritere(payload?.gouvernance), width: '30px', height: '30px', border: '1px solid #000000',
                                                    }" :title="payload?.gouvernance ? payload?.gouvernance : 'Non renseigné'"></span>
                                    </div> -->
                                
                                    <div class="form-group col-md-2 mb-0">
                                        <ValidationProvider name="contrat" rules="" v-slot="{ errors }">
                                            <label class="form-label">Contrat </label>
                                            <!-- <input type="text" class="form-control" name="contrat" id="contrat" v-model="payload.contrat" 
                                            @change="verifyCouleur(payload)" placeholder="saisir la pondération du critère..."> -->
                                            <multi-select v-model="payloadCritere.contrat" deselect-label="Sélectionné" select-label="" :options="criteres"
                                                            placeholder="Sélectionné la pondération du critère..." label="libelle" track-by="critere" @select="verifyCouleur(payloadCritere)"
                                                            :searchable="true">
                                                <template slot="option" slot-scope="{ option }">
                                                    <div class="p-1 text-white"
                                                        :style="{ backgroundColor: option.couleur, padding: '5px 10px' }">
                                                        {{ option.libelle }}
                                                    </div>
                                                </template>
                                                <template slot="singleLabel" slot-scope="{ option }">
                                                    <div class="p-1 text-white" 
                                                        :style="{ backgroundColor: option.couleur, padding: '5px 10px' }">
                                                        {{ option.libelle }}
                                                    </div>
                                                </template>
                                                <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                                                <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                                            </multi-select>
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <!-- <div class="col-md-2 mb-0 mt-6">
                                        <span class="d-inline-block rounded-circle" :style="{
                                                    backgroundColor: couleurCritere(payload?.contrat), width: '30px', height: '30px', border: '1px solid #000000',
                                                    }" :title="payload?.contrat ? payload?.contrat : 'Non renseigné'"></span>
                                    </div> -->
                                
                                    <div class="form-group col-md-2 mb-0">
                                        <ValidationProvider name="execution" rules="" v-slot="{ errors }">
                                            <label class="form-label">Exécution </label>
                                            <!-- <input type="text" class="form-control" name="execution" id="execution" v-model="payload.execution" 
                                            @change="verifyCouleur(payload)" placeholder="saisir la pondération du critère..."> -->
                                            <multi-select v-model="payloadCritere.execution" deselect-label="Sélectionné" select-label="" :options="criteres"
                                                            placeholder="Sélectionné la pondération du critère..." label="libelle" track-by="critere" @select="verifyCouleur(payloadCritere)"
                                                            :searchable="true">
                                                <template slot="option" slot-scope="{ option }">
                                                    <div class="p-1 text-white"
                                                        :style="{ backgroundColor: option.couleur, padding: '5px 10px' }">
                                                        {{ option.libelle }}
                                                    </div>
                                                </template>
                                                <template slot="singleLabel" slot-scope="{ option }">
                                                    <div class="p-1 text-white" 
                                                        :style="{ backgroundColor: option.couleur, padding: '5px 10px' }">
                                                        {{ option.libelle }}
                                                    </div>
                                                </template>
                                                <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                                                <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                                            </multi-select>
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <!-- <div class="col-md-2 mb-0 mt-6">
                                        <span class="d-inline-block rounded-circle" :style="{
                                                    backgroundColor: couleurCritere(payload?.execution), width: '30px', height: '30px', border: '1px solid #000000',
                                                    }" :title="payload?.execution ? payload?.execution : 'Non renseigné'"></span>
                                    </div> -->
                                
                                    <div class="form-group col-md-2 mb-0">
                                        <ValidationProvider name="miseEnService" rules="" v-slot="{ errors }">
                                            <label class="form-label">Mise en service </label>
                                            <!-- <input type="text" class="form-control" name="miseEnService" id="miseEnService" v-model="payload.miseEnService" 
                                            @change="verifyCouleur(payload)" placeholder="saisir la pondération du critère..."> -->
                                            <multi-select v-model="payloadCritere.miseEnService" deselect-label="Sélectionné" select-label="" :options="criteres"
                                                            placeholder="Sélectionné la pondération du critère..." label="libelle" track-by="critere" @select="verifyCouleur(payloadCritere)"
                                                            :searchable="true">
                                                <template slot="option" slot-scope="{ option }">
                                                    <div class="p-1 text-white"
                                                        :style="{ backgroundColor: option.couleur, padding: '5px 10px' }">
                                                        {{ option.libelle }}
                                                    </div>
                                                </template>
                                                <template slot="singleLabel" slot-scope="{ option }">
                                                    <div class="p-1 text-white" 
                                                        :style="{ backgroundColor: option.couleur, padding: '5px 10px' }">
                                                        {{ option.libelle }}
                                                    </div>
                                                </template>
                                                <span slot="noOptions">
                                                    <strong>Liste Vide</strong>
                                                </span>
                                                <span slot="noResult">
                                                    <strong>Aucun Résultat</strong>
                                                </span>
                                            </multi-select>
                                            <small class="form-text text-danger">{{ errors[0] }}</small>
                                        </ValidationProvider>
                                    </div>
                                    <!-- <div class="col-md-2 mb-0 mt-6">
                                        <span class="d-inline-block rounded-circle" :style="{
                                                    backgroundColor: couleurCritere(payload?.miseEnService), width: '30px', height: '30px', border: '1px solid #000000',
                                                    }" :title="payload?.miseEnService ? payload?.miseEnService : 'Non renseigné'"></span>
                                    </div> -->
                                </div>
                                <div class="form-row mt-3">
                                    <div class="form-group col-md-12 mb-0 text-center">
                                        <label class="form-label">Couleur</label>
                                        <span class="d-inline-block rounded-circle"
                                            :style="{
                                            backgroundColor: couleurMeteo(payload.couleur),
                                            width: '150px',
                                            height: '150px',
                                            border: '1px solid #000000',
                                            }"
                                            :title="payload.couleur ? payload.couleur : 'Blanc'"
                                        ></span>
                                        <br><span class="align-middle">{{ payload.couleur ? payload.couleur : 'Blanc' }}</span>
                                        <input type="hidden" name="couleur" id="couleur" v-model="payload.couleur" />
                                    </div>
                                </div>
                                <div class="form-footer mt-2">
                                    <button type="button" class="btn btn-dark mt-4 mb-0" @click="sentBack">
                                        Fermer
                                    </button>
                                    <button class="btn btn-success mt-4 mb-0 mx-5" :disabled="invalid" v-if="save"><span class="fe fe-check"></span> Enregistrer</button>
                                    <button class="btn btn-success mt-4 mb-0 mx-5" :disabled="invalid" v-else><span class="fe fe-check"></span> Modifier</button>
                                </div>
                            </div>
                        </form>
                    </ValidationObserver>
                </div>
            </div>
         </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { reduce } from "lodash";
import * as lang from "vuejs-datepicker/src/locale";

const customLabels = {
  first: '<<',
  last: '>>',
  previous: '<',
  next: '>'
};

export default {
    name: "Meteo",
    data() {
        return {
            lang: lang, loading: false, showList: true,
            payload: {etudes: '', gouvernance: '', contrat: '', execution: '', miseEnService: '', declaredAt: new Date(), idComposante: {}, 
            couleur: '', commentaire: '', nbCriteres: '', score: '', idTypeMeteo: {}, validated: false,}, save: true,
            composantes: [], classeurs: [], classeur: {}, lesComposantes: [], composante: {}, meteos: [], etatComposantes: [], statutComposantes: [],
            meteoEvaluer: {}, payloadCritere: {etudes: {}, gouvernance: {}, contrat: {}, execution: {}, miseEnService: {}, idComposante: {}, },
            currentPage: 1,
            perPage: 10,
            currentSort: 'declaredAt',
            currentSortDir: 'asc',
            criteres: [
                { critere: 1, libelle: 'Rouge', couleur: '#FF0000' },
                { critere: 2, libelle: 'Jaune', couleur: '#FFC000' },
                { critere: 3, libelle: 'Vert', couleur: '#00B050' },
            ], customLabels,
            columns: [],
            reinit: false,
            page: { name: 'size', description: '10 par page', value: 10, type: 'number', used: false },
            showFilter: false,
        }
    },
    computed: {
        //...mapGetters({ items: 'meteo/list' }),
        ...mapGetters({ items: 'composantes/list' }),
        sortedItems() {
            return this.meteos.sort((a, b) => {
                const aVal = this.resolveSortValue(a);
                const bVal = this.resolveSortValue(b);
                if (this.currentSortDir === 'asc') {
                return aVal > bVal ? 1 : -1;
                } else {
                return aVal < bVal ? 1 : -1;
                }
            });
        },
        filtersItemsMeteos(){
            const start = (this.currentPage - 1) * this.perPage;
            return this.sortedItems.slice(start, start + this.perPage);
        },
        fr() {
          return this.lang.fr;
        },
        filtersItems() {
            // const start = (this.currentPage - 1) * this.perPage;
            // return this.sortedItems.slice(start, start + this.perPage);
            if (this.classeur.idClasseur == undefined) {
                console.log('PAR DEFAUT');
                this.lesComposantes = this.items?.content || [];
            } else {
                console.log('IL Y A UN CLASSEUR');
                this.lesComposantes = this.lesComposantes;
            }
            return this.lesComposantes || [];
        },
        pageCount() {
            return Math.ceil(this.meteos.length / this.perPage);
        },
        filters() {
            return this.columns.filter(o => o.used);
        },
        option() {
            return reduce(this.filters, (acc, item) => (acc[item.name] = item.value, acc), {})
        },
    },
    watch: {
        page: {
            deep: true,
            immediate: true,
            handler(value) {
                this.reinit = true;
                this.onSearch();
            }
        }
    },
    mounted() {
        const composanteItem = this.$route.params.composanteItem;
        const showList = this.$route.params.showList;
        if(showList != undefined) this.showList = showList;
        else this.showList = true;
        if(composanteItem) this.payload.idComposante = this.$route.params.composanteItem; this.payloadCritere.idComposante = this.$route.params.composanteItem;
    },
    methods:{
        //...mapActions('meteo', ['all', 'add']),
        ...mapActions('composantes', ['all', 'add', 'allPage']),
        sortBy(column) {
            if (this.currentSort === column) {
                this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc';
            } else {
                this.currentSort = column;
                this.currentSortDir = 'asc';
            }
        },
        changePage(page) {
            if (page >= 1 && page <= this.pageCount) {
                this.currentPage = page;
            }
        },
        resolveSortValue(item) {
            const val = item[this.currentSort];
            return typeof val === 'string' ? val.toLowerCase() : val;
        },
        initPayload() {
            return this.payload = {etudes: '', gouvernance: '', contrat: '', execution: '', miseEnService: '', declaredAt: new Date(), idComposante: {}, 
            couleur: '', commentaire: '', nbCriteres: '', score: '', idTypeMeteo: {}, validated: false,};
        },
        showForm() {
            this.save = true;
            this.initPayload();
            this.showList = false;
        },
        showFormMeteo(item) {
            this.payload.idComposante = {...item};
            this.payloadCritere.idComposante = {...item};
            this.save = true;
            this.showList = false;
        },
        sentBack() {
            this.showList = true;
            this.initPayload();
            this.onSearch();
        },
        sentBackPortefeuille(){
            this.$router.push({ name: 'composantes', params: { showList: true }})
        },
        onSearch(offset) {
            this.$loading(true);
            if (offset > 0) this.option.page = offset - 1;
            if (this.reinit) {
                this.option.page = 0;
                this.reinit = false;
            } 
            if (this.page) this.option.size = this.page.value
            //this.$router.push({ query: this.option }).catch(() => { });
            this.allPage(this.option).finally(() => this.$loading(false));
        },
        onSearchBack(item) {
            item.used = false;
            this.onSearch();
        },
        submit(){
            const self = this;
            if(self.save){
                console.log(self.payload);
                swal({
                    title: "Confirmation",
                    text: "Etes-vous sûr de vouloir enregistrer la météo ?",
                    type: "warning",
                    showCancelButton: true,
                    closeOnConfirm: false,
                    cancelButtonText: "Annuler",
                    confirmButtonText: "Enregistrer",
                    confirmButtonColor: "#7db0b2",
                    cancelButtonColor: "#FF0000",
                    showLoaderOnConfirm: true
                }, function(result) {
                    if (result === true) {
                        self.$loading(true);
                        self.$http.post('/meteo', self.payload)
                        .then(({data}) => {
                            if (data) {
                                swal('Information!', 'Météo enregistrée avec succès.', 'success');
                                self.onSearch();
                                self.initPayload();
                                self.showList = true;                            
                            } else {
                                swal('Information!', 'L\'enregistrement de la météo n\'a pas pu être effectuée.', 'error');
                            }
                        })
                        .catch((error) => {
                            swal('Information!', 'Une erreur est survenue lors de l\'enregistrement. ' + error, 'warning');
                        })
                        .finally(() => self.$loading(false));
                    }
                });
            }else{
                console.log("Editer", self.payload);
                swal({
                    title: "Confirmation",
                    text: "Etes-vous sûr de vouloir modifier la météo ?",
                    type: "warning",
                    showCancelButton: true,
                    closeOnConfirm: false,
                    cancelButtonText: "Annuler",
                    confirmButtonText: "Modifier",
                    confirmButtonColor: "#7db0b2",
                    cancelButtonColor: "#FF0000",
                    showLoaderOnConfirm: true
                }, function(result) {
                    if (result === true) {
                        self.$loading(true);
                        self.$http.put('/meteo/' + self.payload.id, self.payload)
                        .then(({data}) => {
                            if (data) {
                                swal('Information!', 'Météo modifiée avec succès.', 'success');
                                self.onSearch();
                                self.initPayload();
                                self.showList = true;
                            } else {
                                swal('Information!', 'La modification de la météo n\'a pas pu être effectuée.', 'error');
                            }
                        })
                        .catch((error) => {
                            swal('Information!', 'Une erreur est survenue lors de la modification. ' + error, 'warning');
                        })
                        .finally(() => self.$loading(false));
                    }
                });
            }
        },
        edit(value){
            this.$loading(true);
            this.save = false;
            this.payload = {...value};
            this.payloadCritere = {
                idComposante : this.payload.idComposante,
                etudes: this.criteres.find(item => item.critere == this.payload.etudes),
                gouvernance: this.criteres.find(item => item.critere == this.payload.gouvernance),
                contrat: this.criteres.find(item => item.critere == this.payload.contrat),
                execution: this.criteres.find(item => item.critere == this.payload.execution),
                miseEnService: this.criteres.find(item => item.critere == this.payload.miseEnService),
            };
            this.hideModal1();
            this.showForm();
            this.$loading(false);
        },
        drop(item){
            const self = this;
            swal({
                title: "Confirmation",
                text: "Etes-vous sûr de vouloir supprimer la météo ?",
                type: "warning",
                showCancelButton: true,
                closeOnConfirm: false,
                cancelButtonText: "Annuler",
                confirmButtonText: "Supprimer",
                confirmButtonColor: "#7db0b2",
                cancelButtonColor: "#FF0000",
                showLoaderOnConfirm: true
            }, function(result) {
                if (result === true) {
                    self.$loading(true);
                    self.$http.delete('/meteo/' + item.id)
                    .then(({data}) => {
                        swal('Information!', 'Météo supprimée avec succès.', 'success');
                        self.onSearch();
                        self.showList = true;
                    })
                    .catch((error) => {
                        swal('Information!', 'Une erreur est survenue lors de la suppression. ' + error, 'warning');
                    })
                    .finally(() => self.$loading(false));
                }
            });
        },
        handleSelectClasseur(item){
            this.$loading(true);
            this.$http.get('/composantes/classeurs/' + item.idClasseur)
            .then(({data}) =>{
                if (data.length > 0) {
                    console.log(data);
                    this.items = data;
                    this.lesComposantes = data?.content;
                } else {
                    this.lesComposantes = [];
                    swal('Information!', 'Aucune composante disponible pour ce classeur.', 'warning');
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors du chargement des composantes : ' + error, 'warning');
                console.error('Erreur lors du chargement des composantes :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        statusRetardFdr(value) {
            switch (value) {
                case 'Non':
                    return 'success';
                case 'Oui':
                    return 'danger';
                default:
                    return 'danger'; //PROCESSED
            }
        },
        statusEtat(value) {
            switch (value) {
                case 'SUSPENDU':
                    return '#000000';
                case 'ANNULE':
                    return '#000000';
                case 'ACTIF':
                    return '#C6E0B4';
                case 'CLOTURE':
                    return '#8EA9DB';
                case 'DOUBLON':
                    return '#F2F2F2';
                case 'PLANIFIE':
                    return '#F2F2F2';
                case 'A_SUPPRIMER':
                    return '#F2F2F2';
                case 'NON_DEMARRE':
                    return '#F2F2F2';
                case 'A_CONFIRMER':
                    return '#F2F2F2';
                case 'PLUS':
                    return '#F2F2F2';
                case 'X':
                    return '#F2F2F2';
                case 'NA':
                    return '#F2F2F2';
                default:
                    return '#F2F2F2'; //PROCESSED
            }
        },
        statusStatut(value) {
            switch (value) {
                case '00':
                    return '#F2F2F2';
                case '01':
                    return '#E2EFDA';
                case '02':
                    return '#C6E0B4';
                case '03':
                    return '#8EA9DC';
                case '04':
                    return '#ACB9CA';
                default:
                    return '#F2F2F2'; //PROCESSED
            }
        },
        handleStatut(value){
            console.log(value);
            switch (value.statut) {
                case '00': // A planifier
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'INACTIF');
                    break;
                case '01': // Planifié
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'ACTIF');
                    break;
                case '02': // En cours
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'ACTIF');
                    break;
                case '03': // Terminé
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'CLOTURE');
                    break;
                case '04': // Annulé
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'INACTIF');
                    break;
                case '05': // A confirmer
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'A_CONFIRMER');
                    break;
                case '06': // Doublon
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'DOUBLON');
                    break;
                case '07': // Suspendu
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'INACTIF');
                    break;
                case 'A supprimer': // A supprimer
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'A_SUPPRIMER');
                    break;
                case 'N/A': // N/A
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'NA');
                    break;
                default: // A planifier
                    this.payload.etatComposante = this.etatComposantes.find(item => item.etat === 'INACTIF');
                    break;
            }  
        },
        hideModal1() {
            $('#detail-composante-meteo').modal('hide');
        },
        showHistoriqueMeteo(item){
            this.$loading(true);
            this.composante = {...item};
            this.$http.get(`/meteo/composante/${item.idComposante}`)
            .then(({data}) =>{
                if (data.length > 0) {
                    this.meteos = data;
                    this.composante = item;
                    $('#detail-composante-meteo').modal('show');
                } else {
                    this.meteos = [];
                    swal('Information!', 'Aucune météo disponible pour cette composante.', 'warning');
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors du chargement des météos : ' + error, 'error');
                console.error('Erreur lors du chargement des météos :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        verifyCouleur(item){
            console.log(item);
            if(typeof item.idComposante === 'object' && Object.keys(item.idComposante).length === 0) return swal('Information!', 'Veuillez choisir une composante svp.', 'warning');
            var etudes = item.etudes?.critere || -1;
            var gouvernance = item.gouvernance?.critere || -1;
            var contrat = item.contrat?.critere || -1;
            var execution = item.execution?.critere || -1;
            var miseEnService = item.miseEnService?.critere || -1;
            this.$loading(true);
            this.$http.get(`/meteo/evaluerMeteo/${etudes}/${gouvernance}/${contrat}/${execution}/${miseEnService}/${item.idComposante?.etatComposante?.etat}/${item.idComposante?.tepGlobal}`)
            .then(({data}) =>{
                if (data) {
                    console.log('RESULT === ', data);
                    this.meteoEvaluer = data;
                    this.payload.idTypeMeteo = this.meteoEvaluer.idTypeMeteo;
                    this.payload.couleur = this.meteoEvaluer.couleur;
                    this.payload.nbCriteres = this.meteoEvaluer.nbCriteres;
                    this.payload.score = this.meteoEvaluer.score;
                    this.payload.etudes = etudes;
                    this.payload.gouvernance = gouvernance;
                    this.payload.contrat = contrat;
                    this.payload.execution = execution;
                    this.payload.miseEnService = miseEnService;
                    this.couleurMeteo(this.payload.couleur);
                } else {
                    swal('Information!', 'L\'évaluation n\'a pas pu être bien faite.', 'warning');
                }
            })
            .catch((error) => {
                swal('Information!', 'Erreur lors de l\'évaluation de la météo : ' + error, 'error');
                console.error('Erreur lors du chargement des météos :', error);
            })
            .finally(() => {
                this.$loading(false);
            });
        },
        couleurMeteo(value){
            switch (value) {
                case 'Noir':
                    return '#000000';
                case 'Orange':
                    return '#FFC000';
                case 'Rouge':
                    return '#FF0000';
                case 'Vert':
                    return '#00B050';
                case 'Bleu':
                    return '#4472C4';
                case 'Blanc':
                    return '#FFFFFF';
                default:
                    return '#FFFFFF';
            }
        },
        couleurCritere(value){
            if(parseInt(value) >= 3){
                return '#00B050';
            }else if(parseInt(value) >= 2 && parseInt(value) < 3){
                return '#FFC000';
            }else if(parseInt(value) >= 1 && parseInt(value) < 2){
                return '#FF0000';
            }else if(parseInt(value) < 1){
                return '#000000';
            }else {
                return '#FFFFFF';
            }
        },
        selectComposante(item) {
            this.$loading(true);
            this.payload.idComposante = item;
            this.payloadCritere.idComposante = item;
            this.$loading(false);
        },
        showValidationMeteo(){
            this.$router.push({ name: 'validationMeteos'});
        }
    },
    created() {
        this.onSearch();
        this.$http.get('/composantes/all')
            .then(({data}) =>{
                this.composantes = data;
            });
        this.$http.get('/classeurs/all')
            .then(({data}) =>{
                this.classeurs = data;
            });
        this.$http.get('/etatComposante')
        .then(({data}) =>{
            this.etatComposantes = data;
        });
        this.$http.get('/statutComposante')
        .then(({data}) =>{
            this.statutComposantes = data;
        });

        this.columns = [
            { name: 'idComposante', description: 'ID Composante', type: 'text', used: false },
                { name: 'nomComposante', description: 'Nom Composante', type: 'text', used: false },
                // { name: 'idSsProjPag', description: 'Sous Projet Pag', used: false, //type: 'text',
                //     options: this.sousProjetsPag.map(o => ({ key: o.idSsProjPag, value: o.nomSsProjPag })),
                //  },
                { name: 'couleur', description: 'Météo (couleur)', type: 'text', used: false },
                { name: 'suiviCodirAsin', description: 'Suivi Codir ASIN (libellé)', used: false, type: 'text',
                    //options: this.suiviCodirAsins.map(o => ({ key: o.valeur, value: o.libelle })),
                },
                { name: 'chefProjet', description: 'Chef Projet (nom ou prénom(s))', used: false, type: 'text',
                    //options: this.chefProjets.map(o => ({ key: o.idContact, value: o.contact })),
                 },
                { name: 'dafReferent', description: 'DAF Référent (nom ou prénom(s))', used: false, type: 'text',
                    //options: this.dafAsins.map(o => ({ key: o.idContact, value: o.contact })),
                 },
                { name: 'pmoReferent', description: 'PMO Référent (nom ou prénom(s))', used: false, type: 'text',
                    //options: this.pmoAsins.map(o => ({ key: o.idContact, value: o.contact })),
                 },
                 { name: 'poleAsin', description: 'Pole ASIN (nom Pole)', used: false, type: 'text',
                    //options: this.polesAsin.map(o => ({ key: o.idPole, value: o.nomPole })),
                 },
                { name: 'retardFdr', description: 'Retard FDR', type: 'text', used: false },
                { name: 'dateDebutPlanifiee', description: 'Date début planifiée', type: 'text', used: false },
                { name: 'dateFinPlanifiee', description: 'Date fin planifiée', type: 'text', used: false },
                { name: 'etatComposante', description: 'Etat Composante', used: false, type: 'text',
                    //options: this.etatComposantes.map(o => ({ key: o.etat, value: o.libelle })),
                 },
                { name: 'statut', description: 'Statut', used: false, type: 'text',
                    //options: this.statutComposantes.map(o => ({ key: o.statut, value: o.libelle })),
                 },
        ];
    }
}
</script>

<style>

</style>